// extracted by mini-css-extract-plugin
export var option = "_8g-0";
export var optionCard = "_8g-f";
export var optionContent = "_8g-g";
export var optionIcon = "_8g-i";
export var optionIconBox = "_8g-h";
export var optionLabel = "_8g-j";
export var optionPill = "_8g-m";
export var optionPillBadge = "_8g-p";
export var optionPillIcon = "_8g-n";
export var optionPillLabel = "_8g-o";
export var optionRadio = "_8g-k";
export var optionRadioInner = "_8g-l";
export var optionReveal = "_8g-2";
export var optionRevealDelay0 = "_8g-3";
export var optionRevealDelay1 = "_8g-4";
export var optionRevealDelay10 = "_8g-d";
export var optionRevealDelay11 = "_8g-e";
export var optionRevealDelay2 = "_8g-5";
export var optionRevealDelay3 = "_8g-6";
export var optionRevealDelay4 = "_8g-7";
export var optionRevealDelay5 = "_8g-8";
export var optionRevealDelay6 = "_8g-9";
export var optionRevealDelay7 = "_8g-a";
export var optionRevealDelay8 = "_8g-b";
export var optionRevealDelay9 = "_8g-c";
export var optionSelected = "_8g-1";